import React, { useEffect, useState } from 'react';
import { Table, Typography, message, Card, Button, Popconfirm, Input, Row, Col, InputNumber } from 'antd';
import axios from 'axios';
import AppLayout from '../../components/AppLayout';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

const BoMList: React.FC = () => {
  const [boms, setBoms] = useState<any[]>([]);
  const [filteredBoms, setFilteredBoms] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ bom_no: '', product_name: '', minQty: null, maxQty: null });

  const navigate = useNavigate();

  // const fetchBoms = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await axios.get('${process.env.REACT_APP_API_URL}/manufacturing/bom');
  //     setBoms(res.data);
  //   } catch (err) {
  //     message.error('Failed to fetch BoMs');
  //   }
  //   setLoading(false);
  // };

  const handleDelete = async (id: string) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/manufacturing/bom/${id}`);
      message.success('BoM deleted');
      // fetchBoms();
    } catch (err) {
      message.error('Failed to delete BoM');
    }
  };

  useEffect(() => {
    // fetchBoms();

    const demoData = Array.from({ length: 50 }, (_, i) => ({
      _id: `${i + 1}`,
      bom_no: `BOM-${(i + 1).toString().padStart(3, '0')}`,
      product_name: `Product ${i + 1}`,
      quantity: Math.floor(Math.random() * 100) + 1,
      components: Array.from({ length: Math.floor(Math.random() * 5) + 1 }, (_, j) => ({
        component_id: `C-${j + 1}`,
        name: `Component ${j + 1}`
      })),
      created_at: new Date(Date.now() - i * 100000000).toISOString()
    }));

    setBoms(demoData);
    setFilteredBoms(demoData);
  }, []);

  const handleFilterChange = (field: string, value: any) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);

    const filtered = boms.filter(b =>
      (newFilters.bom_no === '' || b.bom_no.includes(newFilters.bom_no)) &&
      (newFilters.product_name === '' || b.product_name.toLowerCase().includes(newFilters.product_name.toLowerCase())) &&
      (newFilters.minQty === null || b.quantity >= newFilters.minQty) &&
      (newFilters.maxQty === null || b.quantity <= newFilters.maxQty)
    );

    setFilteredBoms(filtered);
  };

  const columns = [
    { title: 'BoM No', dataIndex: 'bom_no', key: 'bom_no' },
    { title: 'Product', dataIndex: 'product_name', key: 'product_name' },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' },
    { title: 'Components', dataIndex: 'components', key: 'components', render: (components: any[]) => components?.length ?? 0 },
    { title: 'Created At', dataIndex: 'created_at', key: 'created_at', render: (date: string) => new Date(date).toLocaleString() },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: any) => (
        <>
          <Button onClick={() => navigate(`/manufacturing/boms/${record._id}`)}>Edit</Button>
          <Popconfirm
            title="Are you sure to delete this BoM?"
            onConfirm={() => handleDelete(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <Button danger style={{ marginLeft: 8 }}>Delete</Button>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <AppLayout>
    <Card>
      <Title level={4}>Bill of Materials (BoM) List</Title>
      <Button type="primary" onClick={() => navigate('/manufacturing/add-bom')} style={{ marginBottom: 16 }}>
        Create BoM
      </Button>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={6}>
          <Input
            placeholder="Search BoM No"
            value={filters.bom_no}
            onChange={(e) => handleFilterChange('bom_no', e.target.value)}
          />
        </Col>
        <Col span={6}>
          <Input
            placeholder="Search Product Name"
            value={filters.product_name}
            onChange={(e) => handleFilterChange('product_name', e.target.value)}
          />
        </Col>
        <Col span={6}>
          <InputNumber
            placeholder="Min Quantity"
            value={filters.minQty}
            onChange={(val) => handleFilterChange('minQty', val)}
            style={{ width: '100%' }}
          />
        </Col>
        <Col span={6}>
          <InputNumber
            placeholder="Max Quantity"
            value={filters.maxQty}
            onChange={(val) => handleFilterChange('maxQty', val)}
            style={{ width: '100%' }}
          />
        </Col>
      </Row>
      <Table dataSource={filteredBoms} columns={columns} rowKey="_id" loading={loading} />
    </Card>
    </AppLayout>
  );
};

export default BoMList;
